/* FansBRANDS®: one timer for all campaign clocks, including dynamically loaded sections. */
(() => {
 'use strict';
 if (window.fbClearanceInitialized) return;
 window.fbClearanceInitialized = true;
 const config = window.fbClearance || {};
 const end = Date.parse(config.end);
 let clocks = [], timer, expired = false;
 const isActive = () => config.enabled === true && Number.isFinite(end) && end > Date.now();
 const pad = value => String(value).padStart(2, '0');
 function expire() {
  clearInterval(timer);
  if (window.FansBrandsCampaign) window.FansBrandsCampaign.active = false;
  document.documentElement.classList.remove('fb-clearance-active');
  document.querySelectorAll('[data-fb-campaign]').forEach(node => { node.hidden = true; });
  if (config.serverActive && !expired) {
   expired = true;
   // One navigation restores server-rendered regular banners and the gift selector.
   const url = new URL(window.location.href);
   url.searchParams.set('fb_campaign_ended', String(end));
   if (new URL(window.location.href).searchParams.get('fb_campaign_ended') !== String(end)) window.location.replace(url.toString());
  }
 }
 function tick() {
  if (!isActive()) { expire(); return; }
  const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
  const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
  clocks.forEach(node => Object.entries(values).forEach(([unit,value]) => {
   const target = node.querySelector(`[data-unit="${unit}"]`);
   if (target) target.textContent = pad(value);
  }));
 }
 function setupNav(root) {
  root.querySelectorAll('[data-fb-subnav]').forEach(nav => {
   if (nav.dataset.fbInitialized) return;
   nav.dataset.fbInitialized = 'true';
   const track = nav.querySelector('[data-fb-subnav-track]'), next = nav.querySelector('[data-fb-subnav-next]');
   if (!track || !next) return;
   const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    next.hidden = max < 2;
    const atEnd = track.scrollLeft >= max - 2;
    next.setAttribute('aria-label',atEnd ? 'Înapoi la primele subcategorii' : 'Vezi mai multe subcategorii');
    next.dataset.atEnd = String(atEnd);
   };
   next.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (next.dataset.atEnd === 'true') track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
    else track.scrollBy({ left: Math.max(160, track.clientWidth * .75), behavior: reduce ? 'auto' : 'smooth' });
   });
   track.addEventListener('scroll',update,{passive:true});
   if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
   else window.addEventListener('resize',update,{passive:true});
   update();
  });
 }
 function removeEmbeddedVip(root) {
  if (!isActive()) return;
  root.querySelectorAll('.fb-vip-banner,#fb-vip-banner,.fb-vip-mobile-cta').forEach(node => node.remove());
  root.querySelectorAll('.article-content a,.page__content a').forEach(link => {
   if (/joy-loyalty-page|inregistrare-membru-vip/i.test(link.getAttribute('href') || '') && link.querySelector('img')) link.remove();
  });
 }
 function scan() {
  clocks = Array.from(document.querySelectorAll('.fb-campaign-clock[data-end]'));
  const formatter = new Intl.DateTimeFormat('ro-RO', {day:'numeric',month:'long',year:'numeric',timeZone:'Europe/Bucharest'});
  if (Number.isFinite(end)) document.querySelectorAll('[data-fb-campaign-date]').forEach(node => { node.textContent = formatter.format(end); });
  removeEmbeddedVip(document);
  setupNav(document);
  tick();
 }
 document.addEventListener('click', event => {
  const link = event.target.closest('[data-fb-campaign-event]');
  if (link && isActive() && Array.isArray(window.dataLayer)) window.dataLayer.push({event:link.dataset.fbCampaignEvent,link_url:link.getAttribute('href'),link_text:link.textContent.trim()});
 });
 document.addEventListener('toggle', event => {
  if (event.target.matches?.('.fb-ux-accordion--vip') && event.target.open && isActive() && Array.isArray(window.dataLayer)) window.dataLayer.push({event:'clearance_vip_info_open'});
 }, true);
 scan();
 if (isActive()) timer = setInterval(tick,1000);
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('visibilitychange',() => { if (!document.hidden) tick(); });
 let scheduled = false;
 const observer = new MutationObserver(records => {
  // Ignore our own text updates. Observe element additions from Quick Add, AJAX and CMS apps.
  if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1))) return;
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => { scheduled = false; scan(); });
 });
 observer.observe(document.body,{childList:true,subtree:true});
})();
